module.exports = __webpack_public_path__ + "img/menu_btn.4b8150e4.png";